import LightTooltip from 'Components/LightTooltip'
import React from 'react'
import { Formatter } from 'Utils/Formatter'
import info from './assets/info.svg'

const ToolTipAmount = ({ amount, isMargin, type = '' }) => {
  return (
    <div style={{ display: 'flex', gap: 3, alignItems: 'center' }}>
      <p data-testid={`text-${type}-amount`}>
        {`$${Formatter.Money(amount, {
          rounded: true,
          decimalPrecision: 2,
        })}`}
      </p>
      <LightTooltip title={`$${Formatter.Money(amount)}`} placement="left">
        <img
          style={isMargin && { marginBottom: 9 }}
          src={info}
          alt="info-circle"
        />
      </LightTooltip>{' '}
    </div>
  )
}

export default ToolTipAmount
